export const embedWidgetDefaultColor = "#363e5c";

export const embedWidgetMaxTextContrast = 4.5;
